import LocationOnIcon from '@portalterreno/react-ui-icons/LocationOnIcon';
import React from 'react';

import StyledAnchor from '../StyledAnchor';
import { LocationProps } from './types';

const Location: React.FC<LocationProps> = ({
  commune,
  communeId,
  communeName,
  communeSlug,
  regionName,
  urlOperation,
  urlPropertyType,
  ...rest
}) => {
  return (
    <StyledAnchor
      {...rest}
      href={`${process.env.NEXT_PUBLIC_LEGACY_HOST}/${process.env.NEXT_PUBLIC_COUNTRY}/${urlPropertyType}/${urlOperation}/${commune}/${communeId}-${communeSlug}`}
    >
      <LocationOnIcon /> {regionName}, {communeName}
    </StyledAnchor>
  );
};

export default Location;
